<template>
  <div id="CpapDefaultSetting">
    <section>
      <div id="container-center">
        <h1 style class="title has-text-centered">CPAPデフォルト値設定</h1>
        <div class="tab_area">
          <div class="tab_contents cpapDefaultSettingContents">
            <b-tabs v-model="activeTab" :animated="true"  position="is-centered">
              <b-tab-item label="医療機関情報" icon="mdi mdi-hospital-building">
                <div id="item-contens">
                  <div class="card-content margin-top">
                    <table>
                      <!-- <span class="require"/> -->
                      <tr v-if="isDealer"><th>医療機関</th>
                        <td>
                          <!-- <input type="text" style="width:550px;" v-model="medicalInstitutionName" class="settings" name="医療機関名" validate="required" disabled/> -->
                          <input type="text" style="width:550px;" v-model="medicalInstitutionName" name="医療機関名" disabled/>
                          <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
                        </td>
                      </tr>
                      <!-- <span class="require"/> -->
                      <tr><th>医師名</th>
                        <td>
                          <!-- <input type="text" class="settings" v-model="data.doctorName" maxlength="256" name="医師名" validate="required" :disabled="isDealer&&!institutionId"/> -->
                          <input type="text" v-model="data.doctorName" maxlength="256" name="医師名" :disabled="isDealer&&!institutionId"/>
                        </td>
                      </tr>
                      <!-- <span class="require"/> -->
                      <tr><th>事務担当者名</th>
                        <td>
                          <!-- <input type="text" class="settings" v-model="data.clerkName" maxlength="256" name="事務担当者名" validate="required" :disabled="isDealer&&!institutionId"/> -->
                          <input type="text" v-model="data.clerkName" maxlength="256" name="事務担当者名" :disabled="isDealer&&!institutionId"/>
                        </td>
                      </tr>
                      <template v-if="isDealer">
                        <tr><th>医療機関メールアドレス</th><td><b-checkbox class="cstmCheckBox" v-model="data.mailNotification" :disabled="isDealer&&!institutionId">申込み内容を医療機関にメールで通知する。</b-checkbox></td></tr>
                        <tr v-if="data.mailNotification"><th></th><td><input type="text" v-model="data.mail" maxlength="256" placeholder="例）example@example.com" class="settings" name="医療機関メールアドレス" validate="mail|required" :disabled="isDealer&&!institutionId"></td></tr>
                      </template>
                      <!-- <span class="require"/> -->
                      <tr><th>機器納品先</th>
                        <td><div class="block">
                          <b-radio class="td_radio" name="target" v-model="data.delivaryTarget" native-value="home" :disabled="isDealer&&!institutionId">患者宅</b-radio>
                          <b-radio class="td_radio" name="target" v-model="data.delivaryTarget" native-value="hospital" :disabled="isDealer&&!institutionId">医療機関</b-radio>
                        </div></td>
                      </tr>
                    </table>
                  </div>
                  <!-- <b-button class="innerButton is-primary" @click="regist">更新</b-button> -->
                </div>
              </b-tab-item>
              <b-tab-item label="機器(設定)情報" icon="mdi mdi-devices" v-if="data.prescriptionContent">
                <div id="item-contens">
                  <div class="card-content margin-top">
                    <table>
                      <tr>
                        <!-- <span class="require"/> -->
                        <th>機種</th>
                        <td>
                          <!-- <select id="model" class="settings" name="機種" validate="required" @change="changeModel" v-model="data.reportFormatType" style="width:630px;"> -->
                          <select id="model" name="機種" @change="changeModel" v-model="data.reportFormatType" style="width:630px;">
                            <option v-for="model in modelList" :value="model.reportFormatType" :key="model.reportFormatType">{{ model.itemName }}</option>
                          </select>
                        </td>
                      </tr>
                      <tr v-if="data.reportFormatType">
                        <th>設定情報</th>
                        <td>
                          <table id="prescriptionTable">
                          <template v-for="(content, index) in data.prescriptionContent.filter(val=>{ return val.category===0})">
                            <!-- テキスト項目 -->
                            <tr v-if="content.type==='char' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                              <td>
                                <b-field
                                :type="{'is-danger':errors.has('form2char_'+index)&&!content.disabled}"
                                :message="`${errors.has('form2char_'+index)&&!content.disabled ? errors.first('form2char_'+index) : ''}`">
                                  <input
                                    style="width:350px;"
                                    type="text"
                                    :name="'form2char_'+index"
                                    :data-vv-as="content.displayName"
                                    v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`"
                                    v-model="content.value"
                                    @input="changeSelect(content.displayName,content.value,content.itemName)"
                                    :disabled="content.disabled"/>{{content.unit}}
                                </b-field>
                              </td>
                              <td>
                                <!-- 説明コメント用 -->
                              </td>
                            </tr>
                            <!-- セレクトボックス -->
                            <tr v-if="content.type=== 'sel' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                              <td>
                                <b-field
                                :type="{'is-danger':errors.has('form2sel_'+index)&&!content.disabled}"
                                :message="`${errors.has('form2sel_'+index)&&!content.disabled ? errors.first('form2sel_'+index) : ''}`">
                                  <select 
                                  style="width:350px;"
                                  :name="'form2sel_'+index"
                                  :data-vv-as="content.displayName"
                                  v-model="content.value"
                                  v-validate="`${content.required ? 'required':''}`"
                                  @change="changeSelect(content.displayName,content.value,content.itemName)"
                                  :disabled="content.disabled">
                                    <option
                                    v-for="tmpValue in content.displayValue"
                                    :value="tmpValue.key"
                                    :key="tmpValue.key"
                                    >{{ tmpValue.value }}</option></select>{{content.unit}}
                                </b-field>
                              </td>
                              <td>
                                <!-- 説明コメント用 -->
                              </td>
                            </tr>
                            <!-- カレンダー -->
                            <tr v-if="content.type=== 'calender' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                              <td>
                                <b-field
                                :type="{'is-danger':errors.has('form2calender_'+index)}"
                                :message="errors.first('form2calender_'+index)">
                                  <input style="width:350px;" type="date" :name="'form2calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                                </b-field>
                              </td>
                              <td>
                                <!-- 説明コメント用 -->
                              </td>
                            </tr>
                            <!-- ラジオボタン -->
                            <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                              <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                              <td>
                                <div>
                                  <b-radio
                                  v-for="tmpValue in content.displayValue"
                                  v-model="content.value"
                                  :value="tmpValue.value"
                                  :key="tmpValue.key"
                                  :name="'form2radio_'+index+'_'"
                                  :native-value="tmpValue.key"
                                  style="text-align:left; margin-Right:10px;"
                                  >{{tmpValue.value}}</b-radio>
                                </div>
                                <!-- :disabled="content.isDisabled=='true'" -->
                              </td>
                            </tr>
                            <tr v-if="content.annotation" :key="index+'α'">
                              <td style="white-space:pre-wrap;color:red;" colspan="3">{{content.annotation}}</td>
                            </tr>
                          </template>
                          </table>
                        </td>
                      </tr>
                      <!-- TODO: -->
                      <tr v-if="data.reportFormatType">
                        <th>加湿器</th>
                        <td>
                          <table id="prescriptionTable">
                            <template v-for="(content, index) in data.prescriptionContent.filter(val=>{ return val.category===1})">
                              <!-- テキスト項目 -->
                              <tr v-if="content.type==='char' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1) && (content.displayName=='機種' && !isHospital && !isDealer)" :key="index">
                                <th style="white-space:pre-wrap;width:280px;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                                <td>
                                  <b-field
                                  :type="{'is-danger':errors.has('form4char_'+index)}"
                                  :message="errors.first('form4char_'+index)">
                                    <input style="width:350px;" type="text" :name="'form4char_'+index" :data-vv-as="content.displayName" v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`" v-model="content.value"/>{{content.unit}}
                                    <!-- <span v-if="errors.has('char_'+index)" style="color:red;">{{errors.first('char_'+index)}}</span> -->
                                  </b-field>
                                </td>
                                <td>
                                  <!-- 説明コメント用 -->
                                </td>
                              </tr>
                              <!-- セレクトボックス -->
                              <tr v-if="content.type=== 'sel' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                                <td>
                                  <b-field
                                  :type="{'is-danger':errors.has('form4sel_'+index)}"
                                  :message="errors.first('form4sel_'+index)">
                                    <select
                                    style="width:350px;"
                                    :name="'form4sel_'+index"
                                    :data-vv-as="content.displayName"
                                    v-model="content.value"
                                    v-validate="`${content.required ? 'required':''}`"
                                    @change="changeSelect(content.displayName,content.value)"
                                    :disabled="content.disabled">
                                      <option
                                      v-for="tmpValue in content.displayValue"
                                      :value="tmpValue.key"
                                      :key="tmpValue.key"
                                      >{{ tmpValue.value }}</option></select>{{content.unit}}
                                  </b-field>
                                </td>
                                <td>
                                  <!-- 説明コメント用 -->
                                </td>
                              </tr>
                              <!-- カレンダー -->
                              <!-- <tr v-if="content.type=== 'calender' && data.useMoist && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                                <td>
                                  <b-field
                                  :type="{'is-danger':errors.has('form4calender_'+index)}"
                                  :message="errors.first('form4calender_'+index)">
                                    <input
                                    style="width:350px;"
                                    type="date"
                                    :name="'form4calender_'+index"
                                    :data-vv-as="content.displayName"
                                    v-model="content.value"
                                    v-validate="`${content.required ? 'required':''}`"/>
                                  </b-field>
                                </td>
                                <td> -->
                                  <!-- 説明コメント用 -->
                                <!-- </td>
                              </tr> -->
                              <!-- ラジオボタン -->
                              <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                                <td>
                                  <div>
                                    <b-radio
                                    v-for="tmpValue in content.displayValue"
                                    v-model="content.value"
                                    :value="tmpValue.value"
                                    :key="tmpValue.key"
                                    :name="'form4radio1_'+index"
                                    :native-value="tmpValue.key"
                                    style="text-align:left; margin-Right:10px;"
                                    @click.native="inputRadioValue(tmpValue.key,'useMoist')"
                                    >{{tmpValue.value}}</b-radio>
                                  </div>
                                  <!-- :disabled="content.isDisabled=='true'" -->
                                </td>
                              </tr>
                            </template>
                          </table>
                        </td>
                      </tr>
                      <!-- TODO: -->
                      <tr v-if="data.reportFormatType">
                        <th>通信モジュール</th>
                        <td>
                          <table id="prescriptionTable">
                            <template v-for="(content, index) in data.prescriptionContent.filter(val=>{ return val.category===2})">
                              <!-- テキスト項目 -->
                              <tr v-if="content.type==='char' && data.useModule && !isHideItem(content.displayName) && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1) && ((content.displayName=='機種' && !isHospital && !isDealer) || content.displayName=='E-mailアドレス')" :key="index">
                                <th style="white-space:pre-wrap;width:250px;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                                <td>
                                  <b-field
                                  :type="{'is-danger':errors.has('form4_2char_'+index)}"
                                  :message="errors.first('form4_2char_'+index)">
                                    <input style="width:350px;" type="text" :name="'form4_2char_'+index" :data-vv-as="content.displayName" v-validate="`${content.required ? 'required':''}|validationCheck:${content.value},${encodeURI(content.validationRule)}`" v-model="content.value"/>{{content.unit}}
                                  </b-field>
                                </td>
                                <td>
                                  <!-- 説明コメント用 -->
                                </td>
                              </tr>
                              <!-- セレクトボックス -->
                              <tr v-if="content.type=== 'sel' && data.useModule && !isHideItem(content.displayName) && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                                <td>
                                  <b-field
                                  :type="{'is-danger':errors.has('form4_2sel_'+index)}"
                                  :message="errors.first('form4_2sel_'+index)">
                                    <select style="width:350px;" :name="'form4_2sel_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`">
                                      <option
                                      v-for="tmpValue in content.displayValue"
                                      :value="tmpValue.key"
                                      :key="tmpValue.key"
                                      >{{ tmpValue.value }}</option></select>{{content.unit}}
                                  </b-field>
                                </td>
                                <td>
                                  <!-- 説明コメント用 -->
                                </td>
                              </tr>
                              <!-- カレンダー -->
                              <!-- <tr v-if="content.type=== 'calender' && data.useModule && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                                <td>
                                  <b-field
                                  :type="{'is-danger':errors.has('form4_2calender_'+index)}"
                                  :message="errors.first('form4_2calender_'+index)">
                                    <input style="width:350px;" type="date" :name="'form4_2calender_'+index" :data-vv-as="content.displayName" v-model="content.value" v-validate="`${content.required ? 'required':''}`"/>
                                  </b-field>
                                </td>
                                <td> -->
                                  <!-- 説明コメント用 -->
                                <!-- </td>
                              </tr> -->
                              <!-- ラジオボタン -->
                              <tr v-if="content.type==='radio' && (content.mode.indexOf(0)!=-1 || !data.mode || content.mode.indexOf(data.mode)!=-1)" :key="index">
                                <th style="white-space:pre-wrap;">{{content.displayName}}<span v-if="content.required" class="require"/></th>
                                <td>
                                  <div>
                                    <b-radio
                                    v-for="tmpValue in content.displayValue"
                                    v-model="content.value"
                                    :value="tmpValue.value"
                                    :key="tmpValue.key"
                                    :name="'form4_2radio2_'+index"
                                    :native-value="tmpValue.key"
                                    :disabled="data.reportFormatType==6"
                                    style="text-align:left; margin-Right:10px;"
                                    @click.native="inputRadioValue(tmpValue.key,'useModule')"
                                    >{{tmpValue.value}}</b-radio>
                                  </div>
                                  <!-- :disabled="content.isDisabled=='true'" -->
                                </td>
                              </tr>
                            </template>
                          </table>
                        </td>
                      </tr>
                      <!-- TODO: -->
                      <tr v-if="data.reportFormatType">
                        <th>マスク</th>
                        <td>
                          <table>
                            <tr>
                              <!-- <span class="require"/> -->
                              <th style="white-space:pre-wrap;width:250px;">マスク：種類</th>
                              <td>
                                <input disabled style="width:330px;" type="text" class="4" name="マスク種類" validate="required" v-model="data.maskType"/>
                                <b-button type="is-primary" style="margin-left:10px; width:130px; height:27px;" v-on:click="getMaskMaster()">マスク選択</b-button>
                              </td>
                              <td>
                              </td>
                            </tr>
                            <tr>
                              <th style="white-space:pre-wrap;">マスク：クッションサイズ</th>
                              <td>
                                <input disabled style="width:330px;" type="text" class="4" name="クッションサイズ" validate="required" v-model="data.cushionSize"/>
                              </td>
                              <td></td>
                            </tr>
                            <tr>
                              <th style="white-space:pre-wrap;">マスク：フレームサイズ</th>
                              <td>
                                <input disabled style="width:330px;" type="text" class="4" name="フレームサイズ" validate="required" v-model="data.frameSize"/>
                              </td>
                              <td></td>
                            </tr>
                            <tr>
                              <th style="white-space:pre-wrap;">マスク：固定方法</th>
                              <td>
                                <input disabled style="width:330px;" type="text" class="4" name="固定方法" validate="required" v-model="data.fixingMethod"/>
                              </td>
                              <td></td>
                            </tr>
                            <tr v-if="data.maskType=='その他'">
                              <th style="white-space:pre-wrap;">備考</th>
                              <td>
                                <textarea maxlength="256" style="resize:vertical;width:330px;max-width:330px;height:120px" v-model="data.maskMemo"></textarea>                          
                              </td>
                              <td></td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <!-- <b-button v-if="isHospital" class="innerButton is-primary" @click="registBelongs">更新</b-button> -->
                </div>
              </b-tab-item>
              <!-- <b-tab-item label="付属品情報" icon="set-top-box">
                <div id="item-contens">
                  <div class="card-content margin-top">
                    <table>
                      <tr><th>変更前パスワード<span class="require" /></th><td><input type="password" v-model="data" /></td></tr>
                      <tr><th>変更後パスワード<span class="require" /></th><td><input type="password" v-model="data"/></td></tr>
                      <tr><th>変更後パスワード(確認)<span class="require" /></th><td><input type="password" v-model="data"/></td></tr>
                      <tr><th></th><td>※パスワードは8桁以上5文字以上の<br>&nbsp;&nbsp;&nbsp;&nbsp;異なる文字で入力してください。</td></tr>
                    </table>
                  </div>
                  <b-button v-if="isHospital" class="innerButton is-primary" @click="registBelongs">更新</b-button>
                </div>
              </b-tab-item> -->
            </b-tabs>
            <div>
              <b-button class="backbutton is-primary" @click="regist">更新</b-button>
              <b-button class="backbutton is-primary" @click="back">戻る</b-button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <facilitySelectModal :dealerId="belongsId" @select="setfacility"></facilitySelectModal>
    </b-modal>
    <b-modal :active.sync="maskSelectModalActive" has-modal-card full-screen>
      <cpapMaskSelectModal :formatType="data.reportFormatType" @select="maskSelect"></cpapMaskSelectModal>
    </b-modal>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import FacilitySelectModal from "@/components/mock/philips/common/FacilitySelectModal";
import CpapMaskSelectModal from "@/components/mock/philips/common/CpapMaskSelectModal";

export default {
  name: "CpapDefaultSetting",
  methods: {
    back: function() {
      this.$router.go(-1);
    },
    doSearch: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.externalCpap.getCpapDefaultsettingsPOST({
            body:{
              belongsId:_this.belongsId,
              institutionId: _this.institutionId
            }
          });
        },
        function(result){
          _this.data = result.obj
          // _this.$set(_this.data,"prescriptionContent",[])
        },
        function(result){
          _this.showErrorMessage(result);
    }
      );
    },
    setfacility:  function(facility){
      this.institutionId = facility.id
      this.medicalInstitutionName = facility.orgName;
      this.doSearch();
    },
    regist: async function(){
      // バリデーションチェック
      const validateResult = await this.$validator.validateAll()
      if (!validateResult) {
        this.showErrorMessage("入力内容に誤りがあります。")
        return
      }
      // 医療機関情報/装置情報のバリデーションチェック
      var elements = document.getElementsByClassName("settings")
      var result = this.selfMadeValidation(elements)

      // 納品先情報のバリデーションチェック
      if(!this.data.delivaryTarget){
        result.isError = true
        result.msg = result.msg + "「機器納品先」は必須項目です。\n"
      }

      // マスク情報のバリデーションチェック
      if(this.data.reportFormatType && !this.data.maskItemCode){
        result.isError = true
        result.msg = result.msg + "「マスク」は必須項目です。\n"
      }
      
      if(result.isError){
        this.showErrorMessage(result.msg)
      }else{
        // 処方項目の相関チェック
        var errMsg = ""
        if(this.data.reportFormatType){
          var model = this.modelList.find(item => item.reportFormatType == this.data.reportFormatType)
          switch(model.reportFormatType){
            case 1:
              // ドリームステーションAuto
              var lampStart = this.data.prescriptionContent.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
              if(this.data.mode == "1"){
                var pressureMin = this.data.prescriptionContent.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                var pressureMax = this.data.prescriptionContent.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「最小圧」に「最大圧」以下の値を設定してください。\n"
                }
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n"
                }
              }else{
                var pressureCpap = this.data.prescriptionContent.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n"
                }
              }
              break;
            case 2:
              // ドリームステーションPro
              var lampStart = this.data.prescriptionContent.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
              var pressureCpap = this.data.prescriptionContent.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
              if(Number(lampStart.value) > Number(pressureCpap.value)){
                // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                errMsg = errMsg + "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n"
              }
              break;
            case 3:
              // ドリームステーションGo
              var lampStart = this.data.prescriptionContent.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
              if(this.data.mode == "1"){
                var pressureMax = this.data.prescriptionContent.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                var pressureMin = this.data.prescriptionContent.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「最小圧」に「最大圧」以下の値を設定してください。\n"
                }
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「最小圧」以下の値を設定してください。\n"
                }
              }else{
                var pressureCpap = this.data.prescriptionContent.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n"
                }
              }
              break;
            case 4:
              // ドリームステーションBiPAP Auto
              var lampStart = this.data.prescriptionContent.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
              if(this.data.mode == "4"){
                // CPAPモード
                var pressureCpap = this.data.prescriptionContent.find(val => val.displayName == "CPAP圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(Number(lampStart.value) > Number(pressureCpap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「CPAP圧」以下の値を設定してください。\n"
                }
              }else if(this.data.mode == "8"){
                // Bi-Levelモード
                var epap = this.data.prescriptionContent.find(val => val.displayName == "EPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                var ipap = this.data.prescriptionContent.find(val => val.displayName == "IPAP【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(Number(epap.value) > Number(ipap.value)){
                  // "EPAP【hPa(cmH2O)】" <= "IPAP【hPa(cmH2O)】" で無い時
                  errMsg = errMsg + "「EPAP」に「IPAP」以下の値を設定してください。\n"
                }
                if(Number(lampStart.value) > Number(epap.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「EPAP」以下の値を設定してください。\n"
                }
                var flex = this.data.prescriptionContent.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(flex=="1"){
                  // Bi-Flex
                  if(Number(epap.value) == Number(ipap.value)){
                    // 「IPAPの値≠EPAPの値」でない場合
                    errMsg = errMsg + "「EPAP」「IPAP」に異なる値を設定してください。\n"
                  }
                }else if(flex=="2" || flex=="3"){
                  // C-Flex
                  // C-Flex+
                  if(Number(epap.value) != Number(ipap.value)){
                    // 「IPAPの値=EPAPの値」でない場合
                    errMsg = errMsg + "「EPAP」「IPAP」に同じ値を設定してください。\n"
                  }
                }
              }else if(this.data.mode == "1"){
                // Auto Bi-Levelモード
                var epapMin = this.data.prescriptionContent.find(val => val.displayName == "EPAP最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                var ipapMax = this.data.prescriptionContent.find(val => val.displayName == "IPAP最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(Number(epapMin.value) > Number(ipapMax.value)){
                  // "EPAP最小圧【hPa(cmH2O)】" <= "IPAP最大圧【hPa(cmH2O)】" で無い時
                  errMsg = errMsg + "「EPAP最小圧」に「IPAP最大圧」以下の値を設定してください。\n"
                }
                var psMin = this.data.prescriptionContent.find(val => val.displayName == "PS最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                var psMax = this.data.prescriptionContent.find(val => val.displayName == "PS最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(Number(psMin.value) > Number(psMax.value)){
                  // "PS最小圧【hPa(cmH2O)】" <= "PS最大圧【hPa(cmH2O)】" で無い時
                  errMsg = errMsg + "「PS最小圧」に「PS最大圧」以下の値を設定してください。\n"
                }
                if(Number(lampStart.value) > Number(epapMin.value)){
                  // "ランプスタート圧【hPa(cmH2O)】" <= "EPAP最小圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプスタート圧」に「EPAP最小圧」以下の値を設定してください。\n"
                }
                var flex = this.data.prescriptionContent.find(val => val.displayName == "Flexタイプ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(flex=="1"){
                  // Bi-Flex
                  if(Number(psMin.value)==0 && Number(psMax.value)==0){
                    // 「PS最小圧≠0 または PS最大圧≠0 」でない場合
                    errMsg = errMsg + "「PS最小圧」または「PS最大圧」に0以外の値を設定してください。\n"
                  }
                }else if(flex=="2"){
                  // C-Flex
                  if(Number(psMin.value)!=0 || Number(psMax.value)!=0){
                    // 「PS最小圧=0」且つ「PS最大圧=0」でない場合
                    errMsg = errMsg + "「PS最小圧」「PS最大圧」に0を設定してください。\n"
                  }
                }
              }
              break;
            case 5:
              // エスボックス バイスタルク
              var lampStart = this.data.prescriptionContent.find(val => val.displayName == "ランプ開始圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
              if(this.data.mode == "4"){
                // CPAPモード
                // "ランプ開始圧【hPa(cmH2O)】" <= "CPAP圧【hPa(cmH2O)】" でない時
              }else if(this.data.mode == "1"){
                // Auto CPAPモード
                var pressureMax = this.data.prescriptionContent.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                var pressureMin = this.data.prescriptionContent.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「最小圧」に「最大圧」以下の値を設定してください。\n"
                }
                if(Number(lampStart.value) > Number(pressureMin.value)){
                  // "ランプ開始圧【hPa(cmH2O)】" <= "最小圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「ランプ開始圧」に「最小圧」以下の値を設定してください。\n"
                }
              }
              break;
            case 6:
              // プリズマ ライン (prisma25S)
              if(this.data.mode == "1"){
                // APAPモード
                var pressureMax = this.data.prescriptionContent.find(val => val.displayName == "最大圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                var pressureMin = this.data.prescriptionContent.find(val => val.displayName == "最小圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(Number(pressureMin.value) > Number(pressureMax.value)){
                  // "最小圧【hPa(cmH2O)】" <= "最大圧【hPa(cmH2O)】" でない時
                  errMsg = errMsg + "「最小圧」に「最大圧」以下の値を設定してください。\n"
                }
              }else if(this.data.mode == "7"){
                // Sモード
                var epap = this.data.prescriptionContent.find(val => val.displayName == "EPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                var ipap = this.data.prescriptionContent.find(val => val.displayName == "IPAP圧【hPa（cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(Number(epap.value) > Number(ipap.value)){
                  // "EPAP【hPa(cmH2O)】" <= "IPAP【hPa(cmH2O)】" で無い時
                  errMsg = errMsg + "「EPAP」に「IPAP」以下の値を設定してください。\n"
                }
              }else if(this.data.mode == "9"){
                // autoSモード
                var pdiffMin = this.data.prescriptionContent.find(val => val.displayName == "PDIFF min 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                var pdiffMax = this.data.prescriptionContent.find(val => val.displayName == "PDIFF max 圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
                if(Number(pdiffMin.value) > Number(pdiffMax.value)){
                  // "PDIFF min 圧【hPa(cmH2O)】" <= "PDIFF max 圧【hPa(cmH2O)】" で無い時
                  errMsg = errMsg + "「PDIFF min 圧」に「PDIFF max 圧」以下の値を設定してください。\n"
                }
              }
              break;
          }
          if(errMsg){
            // 相関チェックエラーの場合
            this.showErrorMessage(errMsg)
            return
          }
        }
        
        this.$dialog.confirm({
          title: "デフォルト設定値更新確認",
          message: "デフォルト設定値を画面入力されている値で更新します。",
          confirmText:"OK",
          cancelText: "キャンセル",
          onConfirm: async() => {
            //API呼出し
            var excuteApi = this.setCpapDefaultsettingsPOST;
            var successCallBack = this.setCpapDefaultsettingsPOSTSuccess;
            var errorCallBack = this.setCpapDefaultsettingsPOSTError;
            // WebAPI Call
            this.apiCall(excuteApi, successCallBack, errorCallBack);
          }
        });
      }
    },
    setCpapDefaultsettingsPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.belongsId = this.belongsId
      obj.institutionId = this.institutionId
      obj.sendMedicalInstitutionFlag = obj.delivaryTarget=="hospital"
      return client.apis.externalCpap.setCpapDefaultsettingsPOST({
        body:obj
      });
    },
    setCpapDefaultsettingsPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.doSearch();
      this.showSuccess(result);
    },
    setCpapDefaultsettingsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    changeModel: async function() {
      // 処方値の取得
      this.changeBeforeUseModule = this.data.useModule
      var moduleDate = this.data.prescriptionContent.find(val => val.category==2 && val.type=="calender")
      this.beforeModuleDate = moduleDate && moduleDate.value ? moduleDate.value : ""
      this.data.useMoist = false
      this.data.useModule = false
      this.data.moistSerial = ""
      this.data.moduleSerial = ""
      if(!this.data.reportFormatType && !this.data.itemCode){
        return
      }
      var model
      if(this.data.reportFormatType){
        model = this.modelList.find(val => val.reportFormatType == this.data.reportFormatType)
      } else {
        model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.data.itemCode) != -1)
      }
      this.data.itemCode = model ? model.itemCode : ""
      this.data.reportFormatType = model ? model.reportFormatType : ""
      this.data.prescriptionContent = []
      var excuteApi = this.getPrescriptionValueItemsPOST;
      var successCallBack = this.getPrescriptionValueItemsPOSTSuccess;
      var errorCallBack = this.getPrescriptionValueItemsPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPrescriptionValueItemsPOST: function(client) {
      return client.apis.externalCpap.getPrescriptionValueItemsPOST({
        body:{
          formatType:this.data.reportFormatType
        }
      });
    },
    getPrescriptionValueItemsPOSTSuccess: function(result) {
      this.data.prescriptionContent = result.obj
      this.data.useMoist = true
      this.data.useModule = true
      this.moduleList = ""
      this.data.moduleItemCode = ""
      var model = this.modelList.find(val => val.reportFormatType == this.data.reportFormatType)
      if(model){
        var setItem = this.cpapSetItems.find(val => val.cpapItemCode == model.itemCode)
        if(setItem.module){
          this.moduleList = setItem.module
        }else{
          this.moduleList = ""
          this.data.moduleItemCode = setItem.moduleItemCode
        }
      }
      
      for(var i=0; i<this.data.prescriptionContent.length; i++){
        var item = this.data.prescriptionContent[i]
        if(item.displayName == "モード" && item.defaultValue){
          this.data.mode = item.defaultValue
          continue
        }
        if(item.type=="radio" && item.value=="0"){
          if(item.category==1) this.data.useMoist = false
          if(item.category==2) this.data.useModule = false
        }else if(item.category==2 && model.reportFormatType!=3 && model.reportFormatType!=6){
          // 通信モジュールの関連項目の場合(DSgo,Prisma以外)

          if(item.type=="radio" && !this.changeBeforeUseModule){
            // 処方変更前が無しだった場合、引き継ぐ
            item.value = "0"
            this.data.useModule = false
            continue
          }
          if(item.type=="calender" && this.changeBeforeUseModule && this.beforeModuleDate){
            // 処方変更前が有りだった場合、設置日を引き継ぐ
            item.value = this.beforeModuleDate
          }
        }
        this.changeSelect(item.displayName,item.value,item.itemName)
      }
    },
    getPrescriptionValueItemsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back();
    },
    changeSelect: function(name, value) {
      if(name == "モード"){
        this.data.mode = value
        return
      }
      var model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.data.itemCode) != -1)
      switch(model.reportFormatType){
        case 1:
          // ドリームステーションAuto
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.data.prescriptionContent.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.data.prescriptionContent.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionContent.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          if(name == "ランプ時間【分】"){
            // ランプスタート圧【hPa(cmH2O)】
            var lampStart = this.data.prescriptionContent.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              lampStart.value = "4"
              lampStart.disabled = true
            }else{
              lampStart.disabled = false
            }
            return
          }
          break;
        case 2:
          // ドリームステーションPro
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.data.prescriptionContent.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.data.prescriptionContent.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionContent.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          if(name == "ランプ時間【分】"){
            // ランプスタート圧【hPa(cmH2O)】
            var lampStart = this.data.prescriptionContent.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              lampStart.value = "4"
              lampStart.disabled = true
            }else{
              lampStart.disabled = false
            }
            return
          }
          break;
        case 3:
          // ドリームステーションGo
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.data.prescriptionContent.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionContent.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          if(name == "ランプ時間【分】"){
            // ランプスタート圧【hPa(cmH2O)】
            var lampStart = this.data.prescriptionContent.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              lampStart.value = "4"
              lampStart.disabled = true
            }else{
              lampStart.disabled = false
            }
            return
          }
          break;
        case 4:
          // ドリームステーションBiPAP Auto
          if(name == "Flexタイプ"){
            // "Flex設定"
            var flex = this.data.prescriptionContent.find(val => val.displayName == "Flex設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "ライズタイム"
            var riseTime = this.data.prescriptionContent.find(val => val.displayName == "ライズタイム" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "ライズタイムロック"
            var riseTimeLock = this.data.prescriptionContent.find(val => val.displayName == "ライズタイムロック" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              flex.value = ""
              flex.disabled = true
              riseTime.value = riseTime.defaultValue
              riseTimeLock.value = riseTimeLock.defaultValue
              riseTime.disabled = false
              riseTimeLock.disabled = false
            }else{
              flex.value = flex.defaultValue
              flex.disabled = false
              riseTime.value = ""
              riseTimeLock.value = ""
              riseTime.disabled = true
              riseTimeLock.disabled = true
            }
            return
          }
          if(name == "加湿モード"){
            // 回路温度設定
            var circuit = this.data.prescriptionContent.find(val => val.displayName == "回路温度設定" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0" || value=="1"){
              circuit.value = ""
              circuit.disabled = true
            }else{
              circuit.value = circuit.defaultValue
              circuit.disabled = false
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionContent.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          if(name == "ランプ時間【分】"){
            // ランプスタート圧【hPa(cmH2O)】
            var lampStart = this.data.prescriptionContent.find(val => val.displayName == "ランプスタート圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              lampStart.value = "4"
              lampStart.disabled = true
            }else{
              lampStart.disabled = false
            }
            return
          }
          break;
        case 5:
          // エスボックス バイスタルク
          if(name == "CC+"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.data.prescriptionContent.find(val => val.displayName == "CC+機能有効時間　全治療時間" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.data.prescriptionContent.find(val => val.displayName == "CC+機能有効時間　ランプのみ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              ccAll.value = ""
              ccLamp.value = ""
              ccAll.disabled = true
              ccLamp.disabled = true
            }else{
              ccAll.value = ""
              ccAll.disabled = true
              ccLamp.value = ccLamp.defaultValue
              ccLamp.disabled = false
            }
            return
          }
          if(name == "CC+機能有効時間　全治療時間"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.data.prescriptionContent.find(val => val.displayName == "CC+機能有効時間　全治療時間" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.data.prescriptionContent.find(val => val.displayName == "CC+機能有効時間　ランプのみ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value!="" && value!=null && value!="null"){
              // "CC+機能有効時間　ランプのみ"　非活性
              ccLamp.value = ""
              ccLamp.disabled = true
            }else{
              ccLamp.value = ccLamp.defaultValue
              ccLamp.disabled = false
              ccAll.disabled = true
            }
            return
          }
          if(name == "CC+機能有効時間　ランプのみ"){
            // "CC+機能有効時間　全治療時間"
            var ccAll = this.data.prescriptionContent.find(val => val.displayName == "CC+機能有効時間　全治療時間" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "CC+機能有効時間　ランプのみ"
            var ccLamp = this.data.prescriptionContent.find(val => val.displayName == "CC+機能有効時間　ランプのみ" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value!="" && value!=null && value!="null"){
              ccAll.value = ""
              ccAll.disabled = true
            }else{
              ccAll.value = ccAll.defaultValue
              ccAll.disabled = false
              ccLamp.disabled = true
            }
            return
          }
          if(name == "ランプ機能"){
            // "ランプタイム"
            var lampTime = this.data.prescriptionContent.find(val => val.displayName == "ランプタイム" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "ランプ時間【分】"
            var lampTimeMinutes = this.data.prescriptionContent.find(val => val.displayName == "ランプ時間【分】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            // "ランプ開始圧【hPa(cmH2O)】"
            var lampStart = this.data.prescriptionContent.find(val => val.displayName == "ランプ開始圧【hPa(cmH2O)】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              lampTime.value = ""
              lampTimeMinutes.value = ""
              lampStart.value = ""
              lampTime.disabled = true
              lampTimeMinutes.disabled = true
              lampStart.disabled = true
            }else{
              lampTime.value = lampTime.defaultValue
              lampTimeMinutes.value = lampTimeMinutes.defaultValue
              lampStart.value = lampStart.defaultValue
              lampTime.disabled = false
              lampTimeMinutes.disabled = false
              lampStart.disabled = false
            }
            return
          }
          if(name == "ランプタイム"){
            // "ランプ時間【分】"
            var lampTimeMinutes = this.data.prescriptionContent.find(val => val.displayName == "ランプ時間【分】" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="1"){
              lampTimeMinutes.value = ""
              lampTimeMinutes.disabled = true
            }else{
              // ランプ機能
              var lamp = this.data.prescriptionContent.find(val => val.displayName == "ランプ機能" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
              if(lamp.value!="0"){
                lampTimeMinutes.value = lampTimeMinutes.defaultValue
                lampTimeMinutes.disabled = false
              }
            }
            return
          }
          if(name == "患者情報管理"){
            // 登録方法
            var registMethod = this.data.prescriptionContent.find(val => val.displayName == "登録方法" && (val.mode.indexOf(0) != -1 || val.mode.indexOf(Number(this.data.mode)) != -1))
            if(value=="0"){
              registMethod.value = ""
              registMethod.disabled = true
            }else{
              registMethod.value = registMethod.defaultValue
              registMethod.disabled = false
            }
            return
          }
          break;
        case 6:
          // プリズマ ライン (prisma25S)
          break;
      }
    },
    inputRadioValue: function(result,name){
      switch(name){
        case "useMoist":
          this.data.useMoist = result=="1"
          break;
        case "useModule":
          this.data.useModule = result=="1"
          this.data.moduleItemCode = ""
          break;
      }
    },
    isHideItem: function(displayName) {
      if(displayName == "登録方法"){
        var patientManagement = this.data.prescriptionContent.find(val => val.displayName == "患者情報管理")
        if(patientManagement && patientManagement.value=='0'){
          return true
        }
      }
      if(displayName == "E-mailアドレス"){
        var mobileApply = this.data.prescriptionContent.find(val => val.displayName == "モバイルアプリ")
        if(mobileApply && mobileApply.value=='0'){
          return true
        }
      }
      return false
    },
    getMaskMaster: function() {
      var model = this.modelList.find(val => val.itemCodes && val.itemCodes.indexOf(this.data.itemCode) != -1)
      if(model){
        this.maskSelectModalActive=true
      }else{
        this.showErrorMessage("CPAP機種が選択されていません。")
      }
    },
    maskSelect: function(maskInfo) {
      this.data.maskId = maskInfo.id
      this.data.maskType = maskInfo.maskType
      this.data.maskItemCode = maskInfo.itemCode1
      this.data.cushionSize = maskInfo.cushionSize
      this.data.frameSize = maskInfo.frameSize
      this.data.fixingMethod = maskInfo.fixingMethod
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    var modelList = this.getCpapMaster();
    var cpapSetItems = this.getCpapSetItemList();
    return {
      medicalInstitutionName: isHospital ? userInfo.medicalInstitutionName + " " + userInfo.departmentName : "",
      data: {},
      userInfo: userInfo,
      isHospital,
      isDealer,
      belongsId:userInfo.belongsId,
      institutionId: null,
      activeTab: 0,
      organizationModalActive: false,
      modelList,
      cpapSetItems,
      maskSelectModalActive:false
    };
  },
  computed: {},
  mounted: function(){
    if(this.isHospital){
      this.doSearch()
    }
  },
  components: {
    facilitySelectModal:FacilitySelectModal,
    cpapMaskSelectModal:CpapMaskSelectModal
  },
  created: function() {
    this.$validator.extend("validationCheck", {
      getMessage: field => `入力内容に誤りがあります。再度入力してください。`,
      validate: (value, indexArray) => {
        var ret = false;
        var value = indexArray[0];
        // 正規表現にカンマが含まれるとパラメタ数が変化するのでここで結合する
        var validationRule = "";

        if (value.indexOf("'") != -1) {
          // シングルコーテーションはサーバ側でSQLエラーとなる為、ここではじく
          return false;
        }

        for (var i = 1; i < indexArray.length; i++) {
          validationRule += decodeURI(indexArray[i]);
          if (i != indexArray.length - 1) {
            validationRule += ",";
          }
        }
        validationRule = validationRule.replace(/'/g, "");
        // 入力値チェック
        var regex = RegExp(validationRule);
        if (regex.test(value)) {
          ret = true;
        }
        return ret;
      }
    });
  }
};
</script>

<style>
</style>
<style lang="scss">
.tab_area {
  text-align: center;
}
.tab_contents {
  display: inline-block;
}
#prescriptionTable th{
  width:280px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapDefaultSetting.vue